// extracted by mini-css-extract-plugin
module.exports = {"container":"LandingPage_container__5iirS","name":"LandingPage_name__1OrHX","button":"LandingPage_button__2IqwQ","div":"LandingPage_div__3OWol"};